// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0fVEMvwDKplo_P9F8euoBytptMXIoU3U",
  authDomain: "yuga-core.firebaseapp.com",
  projectId: "yuga-core",
  storageBucket: "yuga-core.appspot.com",
  messagingSenderId: "237396403087",
  appId: "1:237396403087:web:399c213946c4e8c949e1fa",
  measurementId: "G-56MERW9ZWP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
const analytics = getAnalytics(app);